import { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';
import { detectDevice, type AppStoreAudience } from '@/utils/appStores';

export type AppStoreAudienceState = 'unknown' | 'native' | AppStoreAudience;

/** Device for store CTAs. Waits until mount; hides native-app WebViews. */
export const useAppStoreAudience = (): AppStoreAudienceState => {
  const [audience, setAudience] = useState<AppStoreAudienceState>('unknown');

  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      setAudience('native');
      return;
    }
    setAudience(
      detectDevice({
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        maxTouchPoints: navigator.maxTouchPoints,
      })
    );
  }, []);

  return audience;
};
